import React from "react";
import { Link } from "react-router-dom";
import { INDUSTRIES } from "../lib/content";

/**
 * Industries grid — compact, balanced, fits-the-fold.
 * Mobile: 2-col, square tiles.
 * Desktop: 4-col, taller tiles.
 * No feature-hero, no asymmetric column-spans. Just a clean directory.
 */
export default function IndustriesGrid({ tone = "dark" }) {
  const bg = tone === "dark" ? "#070A0D" : "#fafafa";
  const ink = tone === "dark" ? "#fff" : "#0C2A40";

  return (
    <section
      className="hv-section relative px-6 md:px-12 lg:px-20 pt-8 md:pt-12 pb-12 md:pb-16"
      style={{ background: bg, color: ink }}
      data-testid="industries-gateway"
    >
      <div className="max-w-[1500px] mx-auto">
        <div className="flex items-end justify-between gap-6 mb-8 md:mb-12 flex-wrap">
          <div>
            <div
              className="eyebrow mb-3"
              style={{ fontSize: "0.66rem", letterSpacing: "0.32em", color: "#1FB6C1" }}
            >
              Industries
            </div>
            <h2
              className="font-display"
              style={{
                fontSize: "clamp(1.9rem, 4.4vw, 4.4rem)",
                lineHeight: 1.05,
                letterSpacing: "-0.02em",
              }}
            >
              Choose your verse.
            </h2>
          </div>
          <p className="max-w-sm text-[0.95rem] font-light opacity-70">
            One HidroVerse. Each industry, its own water story.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {INDUSTRIES.map((ind) => (
            <Link
              key={ind.slug}
              to={`/industries/${ind.slug}`}
              className="industry-tile block aspect-square"
              data-testid={`industry-tile-${ind.slug}`}
            >
              <img src={ind.hero} alt={ind.name} loading="lazy" />
              <div className="tile-overlay" />
              <div className="tile-label">
                <div>
                  <div
                    className="font-industrial text-white leading-tight max-w-[18ch]"
                    style={{ fontSize: "clamp(0.78rem, 1.1vw, 0.95rem)" }}
                  >
                    {ind.name}
                  </div>
                </div>
                <div className="text-white/70 text-[1rem]">→</div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 md:mt-14 flex justify-center">
          <Link to="/industries" className="ghost-pill" data-testid="industries-explore-all">
            Explore every industry →
          </Link>
        </div>
      </div>
    </section>
  );
}
